import { useQuery } from "react-query";
import { getActiveEmployeesNoEmailAddress } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetActiveNoEmailAddress = () => {
  return useQuery(
    "GetActiveEmployeesNoEmailAddress",
    getActiveEmployeesNoEmailAddress,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetActiveNoEmailAddress;
